import {
    PROFILE_LOAD,
    PROFILE_LOAD_FAIL,
    PROFILE_LOAD_SUCCESS,
} from './constants';

export const profileLoad = () => ({
    type: PROFILE_LOAD,
    payload: null,
});

export const profileLoadSuccess = (data) => ({
    type: PROFILE_LOAD_SUCCESS,
    payload: data,
});

export const profileLoadFail = (data) => ({
    type: PROFILE_LOAD_FAIL,
    payload: data,
});
